import * as angular from 'angular';

import {react2angular} from "react2angular";

import Changelog from "../components/Changelog";

const ngModule = angular.module('reactChangelogModule', [])
    .component('reactChangelog', react2angular(Changelog, [],
        ['server']));

const reactChangelogModuleName = ngModule.name;
export default reactChangelogModuleName;
